import { useUserStore } from "~/stores";
import { useMemo } from "react";
import { PERMISSIONS } from "~/constants/permissions";
// Stores
import { isArrayWithContent } from "~/utils/array";

/**
 * Check if a user has a specific role
 * @param roles - Array of role strings
 * @param role - The role to check for
 * @returns boolean indicating if the role is present
 */
const hasRole = (roles: string[] | undefined, role: string): boolean => {
    if (!roles || roles.length === 0) return false;
    return roles.includes(role);
};

/**
 * Receives a permission and will return true or false
 * if a user is permitted to perform an operation
 */

/**
 * user permission hook
 */
export const usePermission = () => {
    const { user } = useUserStore();

    const mapPermissions = useMemo(() => {
        // User info not loaded => initial permissions
        if (!user) {
            const permissions: { [key: string]: boolean } = {};

            Object.keys(PERMISSIONS).forEach(key => {
                permissions[key] = false;
            });
            return { ...permissions, hasPermissionToEditMaintenance: false };
        }
        const mappedPermissions: { [key: string]: boolean } = {};

        // User info is loaded & the team is not selected => initial permissions + check the roles

        if (!isArrayWithContent(user?.rights)) {
            const permissions: { [key: string]: boolean } = {};

            Object.keys(PERMISSIONS).forEach(key => {
                permissions[key] = false;
            });
            return {
                ...permissions,
                hasPermissionToEditMaintenance: hasRole(
                    user.roles,
                    "SCP.Admin",
                ),
            };
        } else {
            // User info is loaded & the team is selected => map permissions

            Object.keys(PERMISSIONS).forEach(
                key =>
                    (mappedPermissions[key] = user?.rights?.some(
                        (right: { rightId: string }) =>
                            right.rightId ===
                            PERMISSIONS[key as keyof typeof PERMISSIONS],
                    )),
            );
        }

        return {
            ...mappedPermissions,
            hasPermissionToEditMaintenance: hasRole(user.roles, "SCP.Admin"),
        };
    }, [user]);

    return mapPermissions;
};
